import { apiClient } from './base';

export const getShifts = async (params = {}) => {
  try {
    const response = await apiClient.get('/call-center/shifts', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getShiftById = async (id) => {
  try {
    const response = await apiClient.get(`/call-center/shifts/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getShiftDetails = async (id) => {
  try {
    const response = await apiClient.get(`/call-center/shifts/${id}/details`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getShiftCrossSellItems = async (id, params = {}) => {
  try {
    const response = await apiClient.get(`/call-center/shifts/${id}/cross-sell-items`, { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createShift = async (data) => {
  try {
    const response = await apiClient.post('/call-center/shifts', data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateShift = async (id, data) => {
  try {
    const response = await apiClient.put(`/call-center/shifts/${id}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};
